module.exports = __webpack_public_path__ + "static/media/product_grid_tile_icon.c7953e1c.svg";